import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Contacto from "../views/Contacto.vue";
import Promociones from "../views/Promociones.vue";
import Modelos from "@/views/Modelos.vue";
import PruebaDeManejo from "@/views/prueba-de-manejo.vue";
import Formularios from '../views/Formularios.vue'
import VModal from 'vue-js-modal'
import DetalleAuto from '../views/DetalleAuto.vue';
import Terminos from "@/views/Terminos.vue";
import Catalogo from "@/views/Catalogo.vue"
import Garantias from "@/views/Garantias.vue"
import CostosM from "@/views/CostosM.vue"
import Proteccion from "@/views/Proteccion.vue"
import Tecnologia from "@/views/Tecnologia.vue"
import Atencionalcliente from "@/views/Atenciónalcliente.vue"
import Agendatuservicio from "@/views/Agendatuservicio.vue"
import comentarios from "@/views/comentarios.vue"
import asistenciacomputadorasarneses from "@/views/asistenciacomputadorasarneses.vue";
import CotizadorMovil from "@/components/CotizadorMovil.vue"

Vue.use(VueRouter);
Vue.use(VModal);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },

  {
    path: "/contacto",
    name: "Contacto",
    component: Contacto,
  },

  {
    path: "/promociones",
    name: "Promociones",
    component: Promociones,
  },

  {
    path: "/modelos",
    name: "modelos",
    component: Modelos,
  },

  {
    path: "/PruebaDeManejo",
    name: "PruebaDeManejo",
    component: PruebaDeManejo,
  },

  {
    path: "/formularios",
    name: "Formularios",
    component: Formularios,
  },

  {
    path: "/autos/:type",
    name: "DetalleAuto",
    component: DetalleAuto
  },

  {
    path: "/terminos-y-condiciones",
    name: "Terminos",
    component: Terminos
  },
  
  {
    path: "/catalogo",
    name: "Catalogo",
    component: Catalogo
  },

  {
    path: "/garantias",
    name: "Garantias",
    component: Garantias
  },

  {
    path: "/costos-de-mantenimiento",
    name: "CostosM",
    component: CostosM
  },

  {
    path: "/proteccion-suzuki",
    name: "Proteccion",
    component: Proteccion
  },

  {
    path: "/Tecnologia",
    name: "tecnologia",
    component: Tecnologia,
  },

  {
    path: "/Atenciónalcliente",
    name: "Atención al cliente",
    component: Atencionalcliente,
  },

  {
    path: "/Agendatuservicio",
    name: "Agenda tu servicio",
    component: Agendatuservicio,
  },

  {
    path: "/comentarios",
    name: "Comentarios",
    component: comentarios,
  },

  {
    path: "/asistenciacomputadorasarneses",
    name: "asistencia computadoras arneses",
    component: asistenciacomputadorasarneses,
  },

  {
    path: "/components/CotizadorMovil",
    name: "CotizadorMovil",
    component:  CotizadorMovil,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

export default router;
